import { render, staticRenderFns } from "./techerDisplayWidge.vue?vue&type=template&id=7351c8a8"
import script from "./techerDisplayWidge.vue?vue&type=script&lang=js"
export * from "./techerDisplayWidge.vue?vue&type=script&lang=js"
import style0 from "./techerDisplayWidge.vue?vue&type=style&index=0&id=7351c8a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports